import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { myConfig } from '../../config';
import { Loading } from '../layout/Loading';

// React Notification
import { NotificationManager } from 'react-notifications';

// Import the default style for DatePicker
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';

const today = new Date();
const fromYear = today.getFullYear() - 100;
const toYear = today.getFullYear() - 16;
let yearsArr = [];
for (var i = toYear; i >= fromYear; i--) {
  yearsArr.push(i);
}

const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
];

const TestDrive = props => {
  const serverAddress = myConfig.serverAddress;
  const [data, setData] = useState(null);

  const [models, setModels] = useState(null);
  const [currentVeh1s, setCurrentVeh1s] = useState(null);
  const [selectedCurrentVehicle, setSelectedCurrentVehicle] = useState('');
  const [custicLabel, setCusticLabel] = useState('');
  const [currentVeh2, setCurrentVeh2] = useState({
    data: [{ o_model: 'Others' }]
  });

  const [formData, setFormData] = useState({
    custtype: 'I',
    custic: '',
    custname: '',
    custcontact: '',
    contactable: true,
    vehmodel: '',
    dob: 1,
    mob: 1,
    yob: toYear,
    ncb: '0',
    currentveh1: '',
    currentveh2: '',
    currentvehno: '',
    custgender: 'Male',
    passdate: '',
    custoccupation: '',
    custadd1: '',
    custadd2: '',
    custpostal: '',
    custemail: '',
    location: '',
    plateno: '',
    remark: '',
    custnbr: ''
  });
  const [spinnerOn, setSpinnerOn] = useState(false);
  const [drivingLicence, setDrivingLicence] = useState('');

  const onDataChange = e => {
    if (e.target.type === 'checkbox') {
      setFormData({ ...formData, [e.target.name]: e.target.checked });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (props.location.state) {
        const customerData = props.location.state.data;
        setData(customerData);
        formData['custname'] = customerData.name;
        formData[
          'custcontact'
        ] = `${customerData.mobileno.prefix}${customerData.mobileno.areacode} ${customerData.mobileno.nbr}`;
        formData['custnbr'] = customerData.mobileno.nbr;
        formData['custadd1'] = `${
          customerData.address.building ? 'Building' : ''
        } ${customerData.address.building} ${
          customerData.address.block ? 'Block' : ''
        } ${customerData.address.block} ${
          customerData.address.floor ? 'Floor' : ''
        } ${customerData.address.floor}`;
        formData[
          'custadd2'
        ] = `${customerData.address.street} ${customerData.address.country.description}`;
        formData['custpostal'] = customerData.address.postalcode;

        let drivingLicenceClass = '';
        customerData.drivinglicence.qdl.classes.forEach(licenceClass => {
          if (licenceClass.issuedate !== '') {
            drivingLicenceClass += licenceClass.issuedate + ', ';
          }
          if (licenceClass.licenceclass !== '') {
            drivingLicenceClass += licenceClass.licenceclass + ', ';
          }
        });

        let drivingLicence =
          customerData.drivinglicence.qdl.expirydate +
          ', ' +
          drivingLicenceClass +
          customerData.drivinglicence.qdl.validity.code +
          ', ' +
          customerData.drivinglicence.qdl.validity.description;

        if (drivingLicence.trim().charAt(0) === ',') {
          drivingLicence = drivingLicence.slice(1).trim();
        }

        if (drivingLicence.trim().charAt(drivingLicence.length - 1) === ',') {
          drivingLicence = drivingLicence.slice(
            0,
            drivingLicence.trim().length - 1
          );
        }
        setDrivingLicence(drivingLicence);

        const modelsResult = await axios.get(
          `${serverAddress}/api/vehiclemodels`
        );
        setModels(modelsResult.data);

        const currentVeh1sResult = await axios.get(
          `${serverAddress}/api/currentmodels`
        );
        setCurrentVeh1s(currentVeh1sResult.data);
        formData['currentveh1'] = currentVeh1sResult.data.data[0]['o_make'];
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedCurrentVehicle !== '' && selectedCurrentVehicle !== 'NA') {
        const results = await axios.get(
          `${serverAddress}/api/currentmodelsbybranch/` + selectedCurrentVehicle
        );
        if (results.data.length == 0) {
          setCurrentVeh2({ data: [{ o_model: '' }] });
          formData['currentveh2'] = '';
        } else {
          setCurrentVeh2(results.data);
          formData['currentveh2'] = results.data.data[0]['o_model'];
        }
      }
    };

    fetchData();
  }, [selectedCurrentVehicle]);

  const customerType = [
    { value: 'I', label: 'Individual' },
    { value: 'C', label: 'Company' },
    { value: 'F', label: 'Foreigner' }
  ];

  const ncb = [
    { value: '0', label: '0%' },
    { value: '10', label: '10%' },
    { value: '20', label: '20%' },
    { value: '30', label: '30%' },
    { value: '40', label: '40%' },
    { value: '50', label: '50%' }
  ];

  //#region D.O.B

  const [days, setDays] = useState(null);
  const [selectedDayOfBirth, setSelectedDayOfBirth] = useState(1);
  const [selectedMonthOfBirth, setSelectedMonthOfBirth] = useState(1);
  const [selectedYearOfBirth, setSelectedYearOfBirth] = useState(toYear);
  const onDayOfBirthChange = e => {
    setSelectedDayOfBirth(e.target.value);
    formData['dob'] = e.target.value;
  };

  const onMonthOfBirthChange = e => {
    setSelectedMonthOfBirth(e.target.value);
    formData['mob'] = e.target.value;
  };

  const onYearOfBirthChange = e => {
    setSelectedYearOfBirth(e.target.value);
    formData['yob'] = e.target.value;
  };

  const setDaysOfMonth = (month, year) => {
    let daysOfMonth = 0;
    let monthInNum = parseInt(month);
    switch (monthInNum) {
      case 4:
      case 6:
      case 9:
      case 11:
        daysOfMonth = 30;
        break;
      case 2:
        daysOfMonth =
          (year % 4 === 0 && year % 100 !== 0 && year % 400 !== 0) ||
          (year % 100 === 0 && year % 400 === 0)
            ? 29
            : 28;
        break;
      default:
        daysOfMonth = 31;
        break;
    }

    let daysArr = [];
    for (var i = 1; i <= daysOfMonth; i++) {
      daysArr.push(i);
    }

    setDays(daysArr);
    if (!daysArr.includes(selectedDayOfBirth)) {
      setSelectedDayOfBirth(1);
    }
  };

  useEffect(() => {
    if (selectedMonthOfBirth && selectedYearOfBirth) {
      setDaysOfMonth(selectedMonthOfBirth, selectedYearOfBirth);
    }
  }, [selectedMonthOfBirth, selectedYearOfBirth]);

  //#endregion

  const [selectedPassDate, setSelectedPassDate] = useState(null);
  const onPassDatePickerChange = selectedDate => {
    setSelectedPassDate(selectedDate);
    formData['passdate'] = selectedDate;
  };

  const [gender, setGender] = useState({
    gender: ''
  });
  const onGenderChange = e => {
    setGender(e.target.value);
    formData['custgender'] = e.target.value;
  };

  const [custicMaxLength, setCusticMaxLength] = useState(8);
  const onCustomerTypeChange = optionSelected => {
    formData['custtype'] = optionSelected.target.value;
    if (optionSelected.target.value === 'I') {
      setCusticLabel('Customer NRIC');
      setCusticMaxLength(8);
    } else if (optionSelected.target.value === 'C') {
      setCusticLabel('Business Cert. No.');
      setCusticMaxLength(11);
    } else {
      setCusticLabel('Passport No. / FIN No.');
      setCusticMaxLength(11);
    }
  };

  const onCurrentVeh1Change = e => {
    formData['currentveh1'] = e.target.value;
    if (e.target.value === 'DO NOT OWN') {
      setCurrentVeh2({ data: [{ o_model: 'NA' }] });
      formData['currentveh2'] = 'NA';
    } else {
      setSelectedCurrentVehicle(e.target.value);
    }
  };

  const [fieldValidation, setFieldValidation] = useState({
    errors: {}
  });
  const handleValidation = () => {
    let fields = formData;
    let errors = {};
    let isValidForm = true;
    let re = /^[0-9]*$/;
    let today = new Date();

    // custic
    // if (fields['custic']) {
    //   if (fields['custtype'] === 'I') {
    //     if (fields['custic'].length < 8) {
    //       isValidForm = false;
    //       errors['custic'] = `Please enter ${custicLabel} with 8 characters`;
    //     } else {
    //       if (!re.test(fields['custic'].substring(0, 7))) {
    //         isValidForm = false;
    //         errors['custic'] =
    //           'Please enter first 7 characters with numbers only';
    //       }
    //       if (re.test(fields['custic'].charAt(7))) {
    //         isValidForm = false;
    //         errors['custic'] = 'Please enter last character with a letter';
    //       }
    //     }
    //   }

    //   if (fields['custtype'] === 'C') {
    //     if (fields['custic'].length < 11) {
    //       isValidForm = false;
    //       errors['custic'] = `Please enter ${custicLabel} with 11 characters`;
    //     } else {
    //       if (
    //         fields['custic'].charAt(0) !== 'A' &&
    //         fields['custic'].charAt(0) !== 'B'
    //       ) {
    //         isValidForm = false;
    //         errors[
    //           'custic'
    //         ] = `The first letter of the ${custicLabel} must be 'A' or 'B'`;
    //       } else if (re.test(fields['custic'].charAt(9))) {
    //         isValidForm = false;
    //         errors['custic'] = 'Please enter last character with a letter';
    //       } else if (!re.test(fields['custic'].substring(1, 8))) {
    //         isValidForm = false;
    //         errors[
    //           'custic'
    //         ] = `All characters of the ${custicLabel} must be numbers except the first and last characters`;
    //       } else if (
    //         fields['custic'].substring(1, 5) < 1930 ||
    //         fields['custic'].substring(1, 5) > today.getFullYear()
    //       ) {
    //         isValidForm = false;
    //         errors[
    //           'custic'
    //         ] = `The four numbers of the ${custicLabel} from the second character must be a valid year (between 1930 and ${today.getFullYear()})`;
    //       }
    //     }
    //   }
    // }

    if (!fields['custname'] || fields['custname'].trim().length === 0) {
      isValidForm = false;
      errors['custname'] = 'Please enter Customer Name';
    }

    if (
      fields['custadd1'].trim().length === 0 &&
      fields['custadd2'].trim().length === 0
    ) {
      isValidForm = false;
      errors['custadd1'] = 'Please enter Address';
    } else {
      if (fields['custadd1'].length > 50) {
        isValidForm = false;
        errors['custadd1'] = fields['custadd1']
          ? 'Customer Address must not exceed 50 characters'
          : '';
      }

      if (fields['custadd2'].length > 50) {
        isValidForm = false;
        errors['custadd2'] = fields['custadd2']
          ? 'Customer Address must not exceed 50 characters'
          : '';
      }
    }

    if (!fields['custcontact'] || fields['custcontact'].trim().length === 0) {
      isValidForm = false;
      errors['custcontact'] = 'Please enter Customer Contact Number';
    }

    // if (!fields['vehmodel']) {
    //   isValidForm = false;
    //   errors['vehmodel'] = 'Please select Car Model';
    // }

    // if (!fields['plateno']) {
    //   isValidForm = false;
    //   errors['plateno'] = 'Please select Trade Plate Number';
    // }

    setFieldValidation({ errors: errors });
    return isValidForm;
  };

  const onSubmit = async e => {
    e.preventDefault();
    setSpinnerOn(true);

    if (handleValidation()) {
      try {
        const testDriveSubmitted = await axios.post(
          `${serverAddress}/api/testdrive`,
          formData
        );
        let errors = testDriveSubmitted.data.errors;
        if (errors) {
          setSpinnerOn(false);
          errors.forEach(error =>
            NotificationManager.error(error.msg, 'Error!')
          );
        } else {
          setSpinnerOn(false);

          // Redirect to SubmitStatus page after submitting successfully
          props.history.push({
            pathname: '/submitstatus',
            state: { statusCode: 200 }
          });
        }
      } catch (error) {
        setSpinnerOn(false);
        props.history.push({
          pathname: '/submitstatus',
          state: { statusCode: 500 }
        });
      }
    } else {
      setSpinnerOn(false);
      NotificationManager.error('Form has errors', 'Error');
    }
  };

  return (
    <Fragment>
      {currentVeh1s && models && data ? (
        <>
          <form className='form' onSubmit={e => onSubmit(e)}>
            <br />
            <h1 style={{ textAlign: 'center' }}>TEST DRIVE</h1>
            <div className='form-group row'>
              <label className='col-sm-3'>Customer Type</label>
              <div className='col-sm-9'>
                <select
                  className='form-control'
                  name='custtype'
                  onChange={onCustomerTypeChange}
                  defaultValue='I'
                >
                  {customerType.map(type => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* <div className='form-group row'>
              <label className='col-sm-3'>
                {custicLabel === '' ? 'Customer NRIC' : custicLabel}
              </label>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='text'
                  name='custic'
                  maxLength={custicMaxLength}
                  onChange={e => onDataChange(e)}
                />
                <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['custic']}
                </span>
              </div>
            </div> */}
            <div className='form-group row'>
              <div className='col-sm-3'>
                <label>Name as in IC</label>{' '}
                <span style={{ color: 'red' }}>*</span>
              </div>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='text'
                  name='custname'
                  defaultValue={`${data.name}`}
                  onChange={e => onDataChange(e)}
                />
                <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['custname']}
                </span>
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-sm-3'>
                <label>Contact No.</label>{' '}
                <span style={{ color: 'red' }}>*</span>
              </div>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='text'
                  name='custcontact'
                  defaultValue={`${data.mobileno.prefix}${data.mobileno.areacode} ${data.mobileno.nbr}`}
                  onChange={e => onDataChange(e)}
                />
                <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['custcontact']}
                </span>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Contactable via SMS</label>
              <div className='col-sm-9'>
                <input
                  type='checkbox'
                  name='contactable'
                  defaultChecked='true'
                  onChange={e => onDataChange(e)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Vehicle Model</label>
              <div className='col-sm-9'>
                <select
                  className='form-control'
                  name='vehmodel'
                  onChange={e => onDataChange(e)}
                >
                  <option selected disabled>
                    --PLEASE CHOOSE MODEL--
                  </option>
                  {models.data.map(model => (
                    <option key={model.m_code} value={model.m_code}>
                      ({model.m_code.trim()}){' '}
                      {model.m_desc.trim().length > 23
                        ? model.m_desc.substring(0, 23) + '...'
                        : model.m_desc}
                    </option>
                  ))}
                </select>
                {/* <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['vehmodel']}
                </span> */}
              </div>
            </div>
            {/* <div className='form-group row'>
              <label className='col-sm-3'>D.O.B</label>
              <div className='col-sm-9'>
                <div className='form-row'>
                  <div className='col-4 col-sm-4'>
                    <select
                      className='form-control'
                      name='dob'
                      defaultValue='1'
                      onChange={e => onDayOfBirthChange(e)}
                    >
                      {days.map(day => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='col-4 col-sm-4'>
                    <select
                      className='form-control'
                      name='mob'
                      defaultValue='1'
                      onChange={e => onMonthOfBirthChange(e)}
                    >
                      {months.map(month => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='col-4 col-sm-4'>
                    <select
                      className='form-control'
                      name='yob'
                      defaultValue={toYear}
                      onChange={e => onYearOfBirthChange(e)}
                    >
                      {yearsArr.map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div> */}
            <div className='form-group row'>
              <label className='col-sm-3'>NCB</label>
              <div className='col-sm-9'>
                <select
                  className='form-control'
                  name='ncb'
                  onChange={e => onDataChange(e)}
                  defaultValue='0'
                >
                  {ncb.map(ncb => (
                    <option key={ncb.value} value={ncb.value}>
                      {ncb.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Current Model</label>
              <div className='col-sm-9'>
                <div className='form-row'>
                  <div className='col-6 col-sm-6'>
                    <select
                      className='form-control'
                      name='currveh1'
                      onChange={onCurrentVeh1Change}
                    >
                      {currentVeh1s.data.map(currentVeh1 => (
                        <option
                          key={currentVeh1.o_make}
                          value={currentVeh1.o_make}
                        >
                          {currentVeh1.o_make}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='col-6 col-sm-6'>
                    <select
                      className='form-control'
                      name='currveh2'
                      onChange={e => onDataChange(e)}
                      defaultValue={currentVeh2.data[0].o_model}
                    >
                      {currentVeh2.data.map((currentVeh2, index) => (
                        <option
                          key={currentVeh2.o_model}
                          value={currentVeh2.o_model}
                        >
                          {currentVeh2.o_model}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Vehicle No.</label>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='text'
                  name='currvehno'
                  onChange={e => onDataChange(e)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Gender</label>
              <div className='col-sm-9'>
                <div onChange={e => onGenderChange(e)}>
                  <input
                    type='radio'
                    value='Male'
                    name='custgender'
                    onChange={e => onDataChange(e)}
                    defaultChecked
                  />{' '}
                  Male &emsp;&emsp;
                  <input
                    type='radio'
                    value='Female'
                    name='custgender'
                    onChange={e => onDataChange(e)}
                  />{' '}
                  Female
                </div>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Pass Date</label>
              <div className='col-sm-9'>
                <DatePickerInput
                  onChange={onPassDatePickerChange}
                  value={selectedPassDate}
                  className='my-custom-datepicker-component'
                  readOnly
                  displayFormat='DD-MM-YYYY'
                />
                {/* <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['passdate']}
                </span> */}
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Occupation</label>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='text'
                  name='custoccupation'
                  onChange={e => onDataChange(e)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-sm-3'>
                <label>Address</label> <span style={{ color: 'red' }}>*</span>
              </div>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  name='custadd1'
                  type='text'
                  defaultValue={`${data.address.building ? 'Building ' : ''}${
                    data.address.building
                  }${data.address.block ? ' Block ' : ''}${data.address.block}${
                    data.address.floor ? ' Floor ' : ''
                  }${data.address.floor}`}
                  onChange={e => onDataChange(e)}
                />
                <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['custadd1']}
                </span>
                <input
                  className='form-control'
                  name='custadd2'
                  type='text'
                  defaultValue={`${data.address.street} ${data.address.country.description}`}
                  onChange={e => onDataChange(e)}
                />
                <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['custadd2']}
                </span>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Postal Code</label>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='text'
                  name='custpostal'
                  defaultValue={`${data.address.postalcode}`}
                  onChange={e => onDataChange(e)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Email</label>
              <div className='col-sm-9'>
                <input
                  className='form-control'
                  type='email'
                  name='custemail'
                  onChange={e => onDataChange(e)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Location</label>
              <div className='col-sm-9'>
                <select
                  name='location'
                  className='form-control'
                  onChange={e => onDataChange(e)}
                >
                  <option value='LK' selected>
                    Leng Kee
                  </option>
                  <option value='TP'>Toa Payoh</option>
                  <option value='UB'>Ubi</option>
                </select>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Trade Plate Number</label>
              <div className='col-sm-9'>
                <select
                  name='plateno'
                  className='form-control'
                  onChange={e => onDataChange(e)}
                >
                  <option value=''>-- Select Trade Plate Number --</option>
                  <option value='4648S'>4648S -- Toa Payoh</option>
                  <option value='4430S'>4430S -- Toa Payoh</option>
                  <option value='5322S'>5322S -- Toa Payoh</option>
                  <option value='4371S'>4371S -- Leng Kee</option>
                  <option value='3748S'>3748S -- Leng Kee</option>
                  <option value='3362S'>3362S -- Leng Kee</option>
                  <option value='4279S'>4279S -- Leng Kee</option>
                </select>
                {/* <span className='error' style={{ color: 'red' }}>
                  {fieldValidation.errors['plateno']}
                </span> */}
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Remark</label>
              <div className='col-sm-9'>
                <textarea
                  className='form-control'
                  name='remark'
                  onChange={e => onDataChange(e)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3'>Driving Licence</label>
              <div className='col-sm-9'>
                <span className='form-control'>{drivingLicence}</span>
              </div>
            </div>
            <p>
              <input type='submit' className='btn btn-primary' value='Submit' />
            </p>
          </form>
          {spinnerOn ? <Loading /> : <></>}
        </>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  data: state.data
});

export default connect(mapStateToProps)(TestDrive);
